import { render, staticRenderFns } from "./DataTableShop.vue?vue&type=template&id=22251570&"
import script from "./DataTableShop.vue?vue&type=script&lang=js&"
export * from "./DataTableShop.vue?vue&type=script&lang=js&"
import style0 from "./DataTableShop.vue?vue&type=style&index=0&id=22251570&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports